import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Breadcrumb, Col, Row, Typography } from "antd";

import PatientSelfMeasuresTable from "../../../components/Tables/PatientSelfMeasureTable";
import Paragraph from "antd/lib/typography/Paragraph";
import { translate } from "../../../locale";

const { Title } = Typography;

const SelfMeasure = () => {
  const { username } = useParams();
  const location = useLocation();

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl items-start my-10 mx-0 md:mx-10 px-4 md:px-0">
      <Row gutter={16} className="w-full">
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Automediciones")}</Breadcrumb.Item>
          </Breadcrumb>
          <Breadcrumb>
            <Breadcrumb.Item>{username}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span={24} className="mt-6">
          <Title level={3} className="text-center !text-xl md:!text-3xl">
            {translate("Automediciones")}
          </Title>
        </Col>

        <Col span="24" className="mt-6">
          {location?.state?.subscriptions && (
            <PatientSelfMeasuresTable
              subscriptions={location.state.subscriptions}
            />
          )}
          {!location?.state?.subscriptions && (
            <Paragraph className="text-center">
              {translate("No encontramos suscripciones para este paciente.")}
            </Paragraph>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SelfMeasure;
